import React from 'react';
import { Link } from 'react-router-dom'
const AdminMenu = (props) => (
	<section>
		<ul className="nav flex-column">
			<li className="nav-item">
				<Link to={'/admin/rubros'} className="nav-link" >Rubros</Link>
			</li>
			<li className="nav-item">
				<Link to={'/admin/categorias'} className="nav-link" >Categorias</Link>
			</li>
		  <li className="nav-item">
		    <Link to={'/admin/productos'} className="nav-link" >Productos</Link>
		  </li>
		  <li className="nav-item">
		    <Link to={'/admin/pedidos'} className="nav-link" >Pedidos</Link>
		  </li>
			<li className="nav-item">
				<Link to={'/admin/metodos'} className="nav-link" >Metodos de Envio</Link>
			</li>
		</ul>
	</section>
);

export default AdminMenu;



// WEBPACK FOOTER //
// ./src/components/admin_menu.js